import { MaintenanceIcon } from "component/icon";
import React from "react";


const UnderMaintenance = () =>(

    <div className="under-maintenance">
        <div className="wrap">
            <div className="left">
            <h1 className="text-primary">Sorry!</h1>
            <h2>We're doing some maintenance</h2>
            <p>Sorry for the inconvenience. We're working hard to improve your experience and will be back online as soon as possible. Thank you for your patience.</p>
            </div>
            <div className="right">
                <MaintenanceIcon />
            </div>
            
        </div>
    </div>
    
)

export default UnderMaintenance;